function trimOrNull(value: string | undefined): string | null {
  const trimmed = value?.trim();
  return trimmed ? trimmed : null;
}

export function getPostHogProjectToken(): string | null {
  return trimOrNull(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN);
}

export function getPostHogServerHost(): string | null {
  return trimOrNull(process.env.NEXT_PUBLIC_POSTHOG_HOST);
}

export function isPostHogClientConfigured(): boolean {
  return getPostHogProjectToken() !== null;
}

/** Server-side capture needs the ingest host (direct API, not the browser proxy). */
export function isPostHogServerConfigured(): boolean {
  return isPostHogClientConfigured() && getPostHogServerHost() !== null;
}
